export const escapeXml = (s: string): string =>
  s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

export const safeJsonLd = (obj: unknown): string =>
  JSON.stringify(obj).replace(/</g, "\\u003c");
